import * as math from "mathjs";

class Pendulum {
  n: number;
  thetas: number[];
  thetaDots: number[];
  g: number;
  m: number;
  l: number;
  F: number;
  t: number;
  solver: string;

  constructor(
    n = 1,
    thetas = Array(n).fill(0.7 * Math.PI),
    thetaDots = Array(n).fill(0),
    g = -9.8,
    m = 1,
    l = 1,
    F = 1,
    t = 0
  ) {
    this.n = n;
    this.thetas = thetas;
    this.thetaDots = thetaDots;
    this.g = g;
    this.m = m;
    this.l = l;
    this.F = F;
    this.t = t;
    this.solver = "rk4";
  }

  f(thetas, thetaDots) {
    let friction;
    if (thetaDots > 0) friction = -this.F / (this.l ** 2 * this.m);
    else friction = this.F / (this.l ** 2 * this.m);
    if (thetaDots == 0) friction = 0;

    return [
      thetaDots,
      (-this.g * Math.sin(thetas[0])) / this.l -
        this.t / (this.l ** 2 * this.m) +
        friction,
    ];
  }

  Euler(dt, thetas, thetaDots) {
    let k1 = this.f(thetas, thetaDots);

    let thetaDeltas = k1[0] * dt;
    let thetaDotDeltas = k1[1] * dt;

    return [
      math.add(thetas, thetaDeltas),
      (thetaDots = math.add(thetaDots, thetaDotDeltas)),
    ];
  }

  RK4(dt, thetas, thetaDots) {
    let k1 = this.f(thetas, thetaDots);
    let k2 = this.f(
      math.add(thetas, 0.5 * dt * k1[0]),
      math.add(thetaDots, 0.5 * dt * k1[1])
    );
    let k3 = this.f(
      math.add(thetas, 0.5 * dt * k2[0]),
      math.add(thetaDots, 0.5 * dt * k2[1])
    );
    let k4 = this.f(
      math.add(thetas, 1.0 * dt * k3[0]),
      math.add(thetaDots, 1.0 * dt * k3[1])
    );

    let thetaDeltas = (math.add(k1[0], 2 * k2[0], 2 * k3[0], k4[0]) * dt) / 6;
    let thetaDotDeltas =
      (math.add(k1[1], 2 * k2[1], 2 * k3[1], 2 * k4[1]) * dt) / 6;

    return [
      math.add(thetas, thetaDeltas),
      (thetaDots = math.add(thetaDots, thetaDotDeltas)),
    ];
  }

  tick(dt) {
    let newState;
    if (this.solver == "rk4")
      newState = this.RK4(dt, this.thetas, this.thetaDots);
    else newState = this.Euler(dt, this.thetas, this.thetaDots);
    this.thetas = newState[0];
    this.thetaDots = newState[1];
  }

  get coordinates() {
    let x = 0;
    let y = 0;
    let coords = [];
    for (let i = 0; i < this.thetas.length; i++) {
      let theta = this.thetas[i];
      x += this.l * Math.sin(theta);
      y -= this.l * Math.cos(theta);
      coords.push({ x: x, y: y });
    }
    return coords;
  }

  get getl() {
    return this.l;
  }
}

export default Pendulum;
